import React from "react";
import { useEffect, useState, createContext, useRef } from 'react';
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const TitulosSection = ({ titulo, contador }) => {


    return (
        <div className="listado-fiscal-invoicemovimientos-titulo-section">
            {titulo}: {contador}
        </div>
    );
};
